const dev = process.env.NODE_ENV === "development";

export default {
  namespaced: true,
  state: {
    isFullScreen: false, //是否全屏展示  
  },
  mutations: {
    changeIsFullScreen(state, data) {
      state.isFullScreen = data;
    }
  },
  actions: {}
};